import script from "./VInputRadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputRadioGroup.vue?vue&type=script&setup=true&lang=ts"

import "./VInputRadioGroup.vue?vue&type=style&index=0&id=c353edae&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c353edae"]])

export default __exports__